import CloseIcon from '@mui/icons-material/Close';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import mime from 'mime';
import { UrlMediaEmbed } from './UrlMediaEmbed';
import { DownloadUrlButton } from './DownloadUrlButton';
import { useUrlMediaPlayerCtx } from './useUrlMediaPlayer';

/**
 * Simple video/audio media player that requires only a URL and a
 * media type. The media player will be shown in a closable modal.
 */
export function UrlMediaPlayer() {
  const ctx = useUrlMediaPlayerCtx();

  const type = ctx.url ? (ctx.options.type ?? mime.getType(ctx.url)) : null;

  return (
    <Dialog open={!!ctx.url} onClose={() => ctx.reset()} fullWidth maxWidth="sm">
      <DialogTitle
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          gap: 1,
        }}
      >
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          {ctx.options?.title && (
            <>
              <PlayCircleOutlineRoundedIcon />
              {ctx.options.title}
            </>
          )}
        </Box>
        <IconButton size="small" onClick={() => ctx.reset()}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {ctx.url && type && <UrlMediaEmbed url={ctx.url} type={type} autoPlay />}
      </DialogContent>
      <DialogActions>
        <DownloadUrlButton url={`${ctx.url}&download=1`} />
      </DialogActions>
    </Dialog>
  );
}
